// Generated by scripts/generate.py. Do not edit.
export const ACCESS_CATALOG = {
    "resources": [
        {
            "kind": "account",
            "owner_scope": "account",
            "permissions": [
                "account:read",
                "account:set_handle"
            ]
        },
        {
            "kind": "activity_run",
            "owner_scope": "account",
            "permissions": [
                "activity_run:end",
                "activity_run:pause",
                "activity_run:read",
                "activity_run:resume",
                "activity_run:start",
                "activity_run:submit"
            ]
        },
        {
            "kind": "added_activity",
            "owner_scope": "account",
            "permissions": [
                "added_activity:add",
                "added_activity:assign_role",
                "added_activity:bind",
                "added_activity:configure",
                "added_activity:read",
                "added_activity:remove",
                "added_activity:remove_role",
                "added_activity:rename",
                "added_activity:reset",
                "added_activity:unbind"
            ]
        },
        {
            "kind": "auth_session",
            "owner_scope": "account",
            "permissions": [
                "auth_session:list",
                "auth_session:revoke"
            ]
        },
        {
            "kind": "canvas",
            "owner_scope": "account",
            "permissions": [
                "canvas:pair",
                "canvas:read",
                "canvas:unpair"
            ]
        },
        {
            "kind": "entitlement",
            "owner_scope": "account",
            "permissions": [
                "entitlement:read"
            ]
        },
        {
            "kind": "feed",
            "owner_scope": "account",
            "permissions": [
                "feed:read",
                "feed:register",
                "feed:revoke"
            ]
        },
        {
            "kind": "interface_entry",
            "owner_scope": "platform",
            "permissions": [
                "interface_entry:promote",
                "interface_entry:rule"
            ]
        },
        {
            "kind": "lease",
            "owner_scope": "account",
            "permissions": [
                "lease:issue"
            ]
        },
        {
            "kind": "machine",
            "owner_scope": "account",
            "permissions": [
                "machine:list",
                "machine:pair",
                "machine:revoke"
            ]
        },
        {
            "kind": "platform_link",
            "owner_scope": "account",
            "permissions": [
                "platform_link:create",
                "platform_link:remove"
            ]
        },
        {
            "kind": "publish_token",
            "owner_scope": "account",
            "permissions": [
                "publish_token:create",
                "publish_token:list",
                "publish_token:revoke"
            ]
        },
        {
            "kind": "published_version",
            "owner_scope": "platform",
            "permissions": [
                "published_version:publish_held",
                "published_version:revoke"
            ]
        },
        {
            "kind": "role_assignment",
            "owner_scope": "platform",
            "permissions": [
                "role_assignment:grant",
                "role_assignment:list",
                "role_assignment:revoke"
            ]
        },
        {
            "kind": "runtime_scope",
            "owner_scope": "account",
            "permissions": []
        },
        {
            "kind": "space",
            "owner_scope": "account",
            "permissions": [
                "space:archive",
                "space:attach",
                "space:create",
                "space:detach",
                "space:grant_directory",
                "space:grant_permit",
                "space:load",
                "space:manage_members",
                "space:read",
                "space:rename",
                "space:revoke_directory",
                "space:revoke_permit",
                "space:unload"
            ]
        }
    ],
    "roles": [
        {
            "grantable": false,
            "permissions": [
                "account:read",
                "account:set_handle",
                "activity_run:end",
                "activity_run:pause",
                "activity_run:read",
                "activity_run:resume",
                "activity_run:start",
                "activity_run:submit",
                "added_activity:add",
                "added_activity:assign_role",
                "added_activity:bind",
                "added_activity:configure",
                "added_activity:read",
                "added_activity:remove",
                "added_activity:remove_role",
                "added_activity:rename",
                "added_activity:reset",
                "added_activity:unbind",
                "auth_session:list",
                "auth_session:revoke",
                "canvas:pair",
                "canvas:read",
                "canvas:unpair",
                "entitlement:read",
                "feed:read",
                "feed:register",
                "feed:revoke",
                "lease:issue",
                "machine:list",
                "machine:pair",
                "machine:revoke",
                "platform_link:create",
                "platform_link:remove",
                "publish_token:create",
                "publish_token:list",
                "publish_token:revoke",
                "space:archive",
                "space:attach",
                "space:create",
                "space:detach",
                "space:grant_directory",
                "space:grant_permit",
                "space:load",
                "space:manage_members",
                "space:read",
                "space:rename",
                "space:revoke_directory",
                "space:revoke_permit",
                "space:unload"
            ],
            "role": "account_owner"
        },
        {
            "grantable": true,
            "permissions": [
                "interface_entry:promote",
                "interface_entry:rule",
                "published_version:publish_held",
                "published_version:revoke",
                "role_assignment:grant",
                "role_assignment:list",
                "role_assignment:revoke"
            ],
            "role": "platform_admin"
        }
    ],
    "scopes": [
        "account",
        "channel",
        "platform"
    ]
};
